export default __webpack_public_path__ + "static/media/tsu-logo.cdb9d7f6.svg";